import { AlignmentType, Paragraph, TextRun } from "docx";

export const TOCHeadings=new Paragraph({
    alignment: AlignmentType.CENTER,
    spacing:{before:100, after:100},

    children: [
        new TextRun({
            text: "Contents",
            size: 40,
            color: "2D72B5",
            font: "Calibri",
            bold: true,
            italics:false
        })
    ],
})
